import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  report: {},
  recommendation: null,
  status: 'idle',
  error: null,
  recommendationStatus: 'idle',
  recommendationError: null,
  reportVersion: null,
  fullResponse: null
};

export const fetchReport = createAsyncThunk(
  'super-admin/report',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`super-admin/report/${id}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.msg);
    }
  }
);

export const fetchPublicReport = createAsyncThunk(
  'public/report',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`public/reports/${id}`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Error fetching public report');
    }
  }
);

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchReport.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.fullResponse = action.payload;
        state.report = { ...action.payload.report };
        state.recommendation = {
          ...action.payload.recommData?.recommendation?.recommendations,
        };
        state.reportVersion = action.payload.recommData?.recommendation?.version || 1
      })
      .addCase(fetchReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occured';
      })
      .addCase(fetchPublicReport.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchPublicReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.fullResponse = action.payload;
        state.report = { ...action.payload.report };
        state.recommendation = { ...action.payload.recommData?.recommendation?.recommendations };
        state.reportVersion = action.payload.recommData?.recommendation?.version || 1;
      })
      .addCase(fetchPublicReport.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occurred';
      });
  },
});

export default reportSlice.reducer;
